import { Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft'
import { useTranslation } from 'react-i18next'
import { Input, Row, Col } from 'antd'
import Wrapper from 'components/reusables/wrapper'
import { SelectTypeProfile } from 'components/configuration/components/lms-profiles/fields'
import { ProfileRoutes } from 'enum/routes'
import { ColorPicker } from 'components/reusables/colorPicker'
import { Title, Subtitle, Label, Alert } from './styled'
import { Buttons, ProfileTypes } from './components'
import { EditProfileProvider, useEditProfile } from './context'

const EditProfile = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const translationPrefix = 'configuration.lmsProfiles'
  const {
    profile,
    updatedData,
    form: { control },
  } = useEditProfile()

  return (
    <Wrapper shadow>
      <Title>
        <FontAwesomeIcon
          onClick={() => history.push(ProfileRoutes.MAIN)}
          icon={faArrowLeft}
        />
        {profile?.name}
      </Title>
      {updatedData && (
        <Alert>
          <FontAwesomeIcon icon={faExclamationTriangle} />
          {t(`${translationPrefix}.edit.updatedData`)}
        </Alert>
      )}
      <Subtitle>{t(`${translationPrefix}.edit.subtitleV2`)}</Subtitle>
      <Row gutter={24}>
        <Col span={12}>
          <Label>{t(`${translationPrefix}.form.name`)}</Label>
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <Input
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                size="large"
              />
            )}
          />
        </Col>
        <Col span={12}>
          <Label>{t(`${translationPrefix}.form.color`)}</Label>
          <Controller
            control={control}
            name="color"
            render={({ field }) => (
              <ColorPicker value={field.value} onChange={field.onChange} />
            )}
          />
        </Col>
      </Row>
      <Controller
        control={control}
        name="profileType"
        render={({ field }) => (
          <SelectTypeProfile
            value={field.value}
            onChange={(type) => field.onChange(type)}
          />
        )}
      />
      <Controller
        control={control}
        name="profileType"
        render={({ field }) => <ProfileTypes value={field.value} />}
      />
      <Buttons />
    </Wrapper>
  )
}

export default () => (
  <EditProfileProvider>
    <EditProfile />
  </EditProfileProvider>
)
